var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"LayoutGutters mx-0",class:_vm.noPadding ? 'mb-0' : 'mb-5',attrs:{"no-gutters":_vm.noGutters,"align":_vm.align,"justify":_vm.align}},[_c('v-col',{class:_vm.noPadding ? 'pb-0' : undefined,staticStyle:{"max-width":"1300px"},attrs:{"cols":"12"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }